export default {
  name: "DeleteAccount",
  props: ["close"],
  data() {
    return {
      newEmail: "",
      repeatEmail: "",
      invalid: false
    };
  },
  methods: {
    closeModal() {
      this.$store.dispatch("toggleLoginModal");
    },


    relog() {
      this.$store.dispatch('setModalType', 'login');

    }
  },

  mounted() {}
}
